import { useState } from "react";

import { PaginationMetadata } from "../types/Pagination";

interface UsePaginationProps {
  initialPage?: number;
  defaultLimit?: number;
}

export interface UsePaginationReturn {
  page: number;
  setPage: (page: number) => void;
  resetPage: () => void;
  limit: number;
  setPageSize: (limit: number) => void;
  getPaginationMetadata: (metadata?: Partial<PaginationMetadata>) => PaginationMetadata;
}

export const getPaginationValues = (params: URLSearchParams) => ({
  initialPage: params.get("page") ? Number(params.get("page")) : undefined,
  defaultLimit: params.get("limit") ? Number(params.get("limit")) : undefined,
});

export const usePagination = ({ initialPage = 1, defaultLimit = 20 }: UsePaginationProps = {}): UsePaginationReturn => {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(defaultLimit);

  const resetPage = () => setPage(initialPage);
  const setPageSize = (newLimit: number) => {
    setPage(1);
    setLimit(newLimit);
  };

  const getPaginationMetadata = (metadata?: Partial<PaginationMetadata>): PaginationMetadata => {
    if (!metadata) {
      return { itemCount: 0, totalItems: 0, limit, totalPages: 1, currentPage: page };
    }

    return {
      ...metadata,
      itemCount: metadata.itemCount ?? metadata.totalItems ?? 0,
      totalItems: metadata.totalItems ?? 0,
      limit: metadata.limit ?? limit,
      totalPages: metadata.totalPages ?? Math.max(1, Math.ceil((metadata.totalItems ?? 0) / limit)),
      currentPage: metadata.currentPage ?? page,
    };
  };

  return { page, setPage, resetPage, limit, setPageSize, getPaginationMetadata };
};
